<template>
  <div class="order-list-container">
    <div class="order-list-content">
      <div class="order-list-header">
        <h2>订单管理</h2>
        <p>查看和管理所有订单</p>
      </div>

      <div class="filter-section">
        <el-select v-model="filterStatus" placeholder="订单状态" @change="handleFilterChange" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="待支付" value="pending"></el-option>
          <el-option label="已完成" value="completed"></el-option>
          <el-option label="已失败" value="failed"></el-option>
          <el-option label="已取消" value="cancelled"></el-option>
        </el-select>

        <el-select v-model="filterPaymentMethod" placeholder="支付方式" @change="handleFilterChange" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="支付宝" value="alipay"></el-option>
          <el-option label="微信支付" value="wechat"></el-option>
          <el-option label="银联支付" value="union"></el-option>
        </el-select>
      </div>

      <el-table :data="orders" border stripe>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="order_no" label="订单号" width="200"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
        <el-table-column prop="plan_name" label="订阅方案" width="120"></el-table-column>
        <el-table-column prop="amount" label="金额" width="100">
          <template slot-scope="scope">
            ¥{{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column prop="payment_method" label="支付方式" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.payment_method === 'alipay'">支付宝</span>
            <span v-else-if="scope.row.payment_method === 'wechat'">微信支付</span>
            <span v-else-if="scope.row.payment_method === 'union'">银联支付</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="period" label="周期" width="80"></el-table-column>
        <el-table-column prop="paid_at" label="支付时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.paid_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewOrder(scope.row)">查看</el-button>
            <el-dropdown @command="handleCommand($event, scope.row)">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="complete" v-if="scope.row.status === 'pending'">标记完成</el-dropdown-item>
                <el-dropdown-item command="cancel" v-if="scope.row.status === 'pending'">取消订单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;"
      ></el-pagination>

      <el-dialog title="订单详情" :visible.sync="dialogVisible" width="600px">
        <div v-if="currentOrder" class="order-detail">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="订单ID">{{ currentOrder.id }}</el-descriptions-item>
            <el-descriptions-item label="订单号">{{ currentOrder.order_no }}</el-descriptions-item>
            <el-descriptions-item label="用户ID">{{ currentOrder.user_id }}</el-descriptions-item>
            <el-descriptions-item label="订阅方案">{{ currentOrder.plan_name }}</el-descriptions-item>
            <el-descriptions-item label="周期">{{ currentOrder.period }}</el-descriptions-item>
            <el-descriptions-item label="金额">¥{{ currentOrder.amount }}</el-descriptions-item>
            <el-descriptions-item label="支付方式">
              <span v-if="currentOrder.payment_method === 'alipay'">支付宝</span>
              <span v-else-if="currentOrder.payment_method === 'wechat'">微信支付</span>
              <span v-else-if="currentOrder.payment_method === 'union'">银联支付</span>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="getStatusType(currentOrder.status)">
                {{ getStatusText(currentOrder.status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="交易流水号">{{ currentOrder.transaction_id || '-' }}</el-descriptions-item>
            <el-descriptions-item label="支付时间">{{ formatDate(currentOrder.paid_at) }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ formatDate(currentOrder.created_at) }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderList',
  data() {
    return {
      orders: [],
      filterStatus: '',
      filterPaymentMethod: '',
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      currentOrder: null
    }
  },
  mounted() {
    this.loadOrders()
  },
  methods: {
    async loadOrders() {
      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }
        if (this.filterStatus) {
          params.status = this.filterStatus
        }
        if (this.filterPaymentMethod) {
          params.payment_method = this.filterPaymentMethod
        }
        
        const response = await axios.get('/admin/orders', { params })
        if (response.data.code === 200) {
          this.orders = response.data.data.orders
          this.pagination.total = response.data.data.total
        }
      } catch (error) {
        console.error('加载订单列表失败:', error)
        this.$message.error('加载订单列表失败')
      }
    },
    handleFilterChange() {
      this.pagination.page = 1
      this.loadOrders()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrders()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadOrders()
    },
    viewOrder(order) {
      this.currentOrder = order
      this.dialogVisible = true
    },
    async handleCommand(command, order) {
      if (command === 'complete') {
        await this.updateOrderStatus(order.id, 'completed')
      } else if (command === 'cancel') {
        await this.updateOrderStatus(order.id, 'cancelled')
      } else if (command === 'delete') {
        this.$message.info('删除功能暂未开放')
      }
    },
    async updateOrderStatus(orderId, status) {
      try {
        const response = await axios.put(`/admin/orders/${orderId}/status?status=${status}`)
        if (response.data.code === 200) {
          this.$message.success('订单状态更新成功')
          this.loadOrders()
        }
      } catch (error) {
        console.error('更新订单状态失败:', error)
        this.$message.error('更新订单状态失败')
      }
    },
    getStatusType(status) {
      const statusMap = {
        'pending': 'warning',
        'completed': 'success',
        'failed': 'danger',
        'cancelled': 'info'
      }
      return statusMap[status] || 'info'
    },
    getStatusText(status) {
      const statusMap = {
        'pending': '待支付',
        'completed': '已完成',
        'failed': '已失败',
        'cancelled': '已取消'
      }
      return statusMap[status] || status
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.order-list-container {
  padding: 20px 0;
}

.order-list-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.order-list-header {
  margin-bottom: 30px;
}

.order-list-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.order-list-header p {
  font-size: 14px;
  color: #aaa;
  margin: 0;
}

.filter-section {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.filter-section .el-select {
  width: 150px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
}

.order-detail {
  padding: 10px 0;
}
</style>
